import { hashApiKey } from "./apiKeys";

export async function hashScimToken(token: string): Promise<string> {
  return hashApiKey(token);
}
